import { useEffect, useMemo, useState } from "react";
import { TrashIcon, WriteIcon } from "../icons";
import Footer from "../layout/footer";
import { extractFirstImageSrc, removeImageTags } from "../utils/common";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { isEmpty } from "lodash";
import Header from "../layout/header";

export default function BlogListPage() {
  const [data, setData] = useState<
    {
      id: number;
      code: string;
      title: string;
      content: string;
      date: string;
    }[]
  >([]);
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    fetchBlog();
  }, []);

  const fetchBlog = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_BASE_URL!, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to add row");
      }
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error("Error adding row:", error);
    }
  };

  const deleteBlog = async (id: number) => {
    confirmAlert({
      title: "Confirmer la suppression",
      message: "Etes-vous sure de vouloir supprimer cet article ?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const response = await fetch(
                process.env.REACT_APP_BASE_URL + `/${id}`,
                {
                  method: "DELETE",
                }
              );

              if (!response.ok) {
                throw new Error("Failed to add row");
              }
              const copy = data.filter((item) => item.id !== id);
              setData(copy);
            } catch (error) {}
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const filterBlog = useMemo(() => {
    if (isEmpty(search)) {
      return data;
    }

    return data.filter((item) =>
      item.title.toLowerCase().includes(search.toLowerCase())
    );
  }, [data, search]);

  return (
    <div className="bg-primary-0">
      <main className="pb-4 md:pb-6 flex flex-col px-4 md:px-6 lg:px-8 xl:px-16 py-8 h-full w-full md:max-w-[100rem] 2xl:max-w-[1060px] md:mx-auto gap-6 font-dmsans">
        <Header inBLog={true} />

        <div className="flex flex-col items-center justify-center gap-4 w-full">
          <h6 className="text-sm text-primary-100 font-medium">Resources</h6>
          <h1 className="text-5xl text-primary-25 font-semibold">
            Mes articles
          </h1>
          <p className="text-primary-15/90 font-normal text-base">
            Tool and strategies modern teams need to help their companies grow.
          </p>
        </div>
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-4">
          <div className="flex flex-row items-center gap-4">
            <input
              type="text"
              id="fullName"
              name="fullName"
              className="h-12 text-base w-full md:w-96 font-normal placeholder:text-xs md:placeholder:text-base placeholder:font-normal border rounded-lg px-4 focus:outline-none"
              placeholder="Rechercher..."
              required={true}
              onChange={(e) => setSearch(e.target.value)}
            />
            {/* <button className="bg-primary-100 hover:bg-primary-100/80 font-normal text-sm text-white h-10 px-6 rounded-md">
              Rechercher
            </button> */}
          </div>
          <a
            href="/write-blog"
            className="flex items-center gap-2 bg-primary-5 hover:bg-primary-5/80 font-normal text-sm text-white h-10 px-6 rounded-md"
          >
            <WriteIcon className="h-4 w-4" /> <span>Rédiger un article</span>
          </a>
        </div>
        {filterBlog.map((item) => {
          return (
            <div
              key={item.id}
              className="group relative flex flex-col md:flex-row gap-6 bg-white hover:bg-transparent p-2 rounded-lg"
            >
              {extractFirstImageSrc(item.content) && (
                <img
                  src={extractFirstImageSrc(item.content)!}
                  className="w-40 h-40 bg-cover"
                  style={{ objectFit: "cover" }}
                />
              )}

              <div className="flex flex-col gap-2">
                {/* <h6 className="text-xs text-primary-100 font-medium">
                  Finance
                </h6> */}
                <h3 className="text-sm md:text-xl md:w-[500px] font-semibold text-primary-25">
                  {item.title}
                </h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: removeImageTags(item.content),
                  }}
                  className="text-xs md:text-sm font-light line-clamp-6 text-primary-15/80 md:w-[500px]"
                ></p>
              </div>
              <div className="hidden group-hover:flex absolute right-2 top-2  flex-col gap-2">
                <a
                  href={`/write-blog?edit=${item.id}`}
                  className="flex items-center gap-2 bg-white hover:bg-white/80 shadow-sm font-normal text-sm text-[#64748B] h-8 px-2 rounded-md"
                >
                  <WriteIcon className="h-4 w-4 text-[#64748B]" />{" "}
                  <span>Modifier</span>
                </a>
                <button
                  onClick={() => deleteBlog(item.id)}
                  className="flex items-center gap-2 bg-white hover:bg-white/80 shadow-sm font-normal text-sm text-[#64748B] h-8 px-2 rounded-md"
                >
                  <TrashIcon className="h-4 w-4" /> <span>Supprimer</span>
                </button>
              </div>
            </div>
          );
        })}
      </main>
      <div className="bg-white pt-4 md:pt-4">
        <Footer />
      </div>
    </div>
  );
}
